/**
 * Shared task utilities
 *
 * Common functions used across exec, run, and exec-batch commands.
 */

/**
 * Generate a unique task ID.
 * Format: task-<base36-timestamp>-<random-4-chars>
 */
export function generateTaskId(): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 6);
  return `task-${timestamp}-${random}`;
}

/**
 * Truncate a string for display, adding ellipsis if needed.
 */
export function truncate(str: string, maxLen: number): string {
  if (str.length <= maxLen) return str;
  return str.substring(0, maxLen - 3) + '...';
}
